import type { CommissionRequirementProgress, UpcomingCommission } from '@sorrem/shared';

/** One requirement still needed, as a sentence. */
function describeRequirement(requirement: CommissionRequirementProgress): string {
    switch (requirement.type) {
        case 'crucible-victories': {
            const remaining = requirement.count - requirement.current;
            const crucibles = remaining === 1 ? 'Crucible' : 'Crucibles';
            return `Win ${remaining} more ${crucibles} to be offered your next commission (${requirement.current} of ${requirement.count} won).`;
        }
        default: {
            // A new requirement kind must say how it reads here.
            const unknownRequirement: never = requirement.type;
            throw new Error(`Unknown commission requirement: ${String(unknownRequirement)}`);
        }
    }
}

/**
 * The fallback for an upcoming commission with no authored note: what the
 * character still needs before it is offered:
 * "Win 3 more Crucibles to be offered your next commission (1 of 4 won)."
 */
export function describeUpcomingCommission(upcoming: UpcomingCommission): string {
    return upcoming.requires.map(describeRequirement).join(' ');
}
